import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export type Period =
  | 'this_month'
  | 'last_month'
  | 'this_quarter'
  | 'this_year'
  | 'last_12_months'
  | 'this_fiscal_year'
  | 'last_fiscal_year'
  | 'custom'
export type Grouping = 'month' | 'origin' | 'membership_level'
export type Granularity = 'month' | 'quarter' | 'year'

const periodOptions: Array<{ value: Period; label: string }> = [
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'this_year', label: 'This year' },
  { value: 'last_12_months', label: 'Last 12 months' },
  { value: 'this_fiscal_year', label: 'This fiscal year' },
  { value: 'last_fiscal_year', label: 'Last fiscal year' },
  { value: 'custom', label: 'Custom' },
]

export function PeriodField({
  value,
  onChange,
}: {
  value: Period
  onChange: (value: Period) => void
}) {
  return (
    <SelectField
      label="Period"
      value={value}
      options={periodOptions}
      onChange={(next) => onChange(next as Period)}
    />
  )
}

export function GroupingField({
  value,
  onChange,
}: {
  value: Grouping
  onChange: (value: Grouping) => void
}) {
  return (
    <SelectField
      label="Group by"
      value={value}
      options={[
        { value: 'month', label: 'Month' },
        { value: 'origin', label: 'Origin' },
        { value: 'membership_level', label: 'Membership Level' },
      ]}
      onChange={(next) => onChange(next as Grouping)}
    />
  )
}

export function GranularityField({
  value,
  onChange,
}: {
  value: Granularity
  onChange: (value: Granularity) => void
}) {
  return (
    <SelectField
      label="Granularity"
      value={value}
      options={[
        { value: 'month', label: 'Month' },
        { value: 'quarter', label: 'Quarter' },
        { value: 'year', label: 'Year' },
      ]}
      onChange={(next) => onChange(next as Granularity)}
    />
  )
}

function SelectField({
  label,
  value,
  options,
  onChange,
}: {
  label: string
  value: string
  options: Array<{ value: string; label: string }>
  onChange: (value: string) => void
}) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-9 w-40" aria-label={label}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
